module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/81961fc28425b9bc8e9d8e4acfab564f.png";